import React, { useEffect, useState } from "react";
import { 
  Card, 
  Button, 
  List, 
  Row, 
  Col, 
  Typography, 
  Table, 
  Tag, 
  notification,
  Collapse, 
  Spin
} from "antd";
import { Modal } from 'antd';
import { 
  CheckCircleFilled,
  CheckCircleOutlined, 
  CloseCircleOutlined,
  LoadingOutlined,
  StarFilled 
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { axiosInstance } from '../../util/Api';
import LoadingPage from "../myProfile/LoadingPage";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { fetchStart, fetchSuccess } from "appRedux/actions/Common";
import { createSubscriptionOrder, loadRazorpay, verifyRazorpayPayments } from "../../util/RazorpayHelper";


const { Title, Text } = Typography;
const { Panel } = Collapse;

const SubscriptionPlans = ({ userDatas, setUserDatas }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isMobile } = useGetBreakpoints();
  const usersData = useSelector(({ auth }) => auth?.userData);
  console.log("usersData",usersData)
  const isLoading = useSelector(({ common }) => common.loading);

  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  // const [ isFreightForwarder, setIsFreightForwarder] = useState(false);
  const [planDuration, setPlanDuration] = useState('monthly'); // 'monthly' or 'yearly'
  const isFreightForwarder =usersData?.businessTypeId === 6 ||usersData?.businessTypeId === 7 ;
  const isExporter =usersData?.businessTypeId === 2 ;
  const isManuCumExporter =usersData?.businessTypeId === 8 ;
  const isManufacturerComissionAgent =usersData?.businessTypeId === 3 || usersData?.businessTypeId === 4 ;
  const isCha = usersData?.businessTypeId === 5;
  const icChaCumFreight =  usersData?.businessTypeId === 9;

  //   const { rzpKey } = getPaymentConfig();
  // console.log(`Initializing Razorpay in  mode with key: ${rzpKey.substring(0, 8)}...`);

  // console.log("BusinessType",BusinessType)
  const [initialLoading, setInitialLoading] = useState(true);

  const renderFeatureCell = (value) => {
    // If the value is a string containing a number, display the number
    if (typeof value === 'string' && !isNaN(value)) {
      return <Text strong>{value}</Text>;
    }
    // Boolean values show checkmark/cross
    return value ? (
      <CheckCircleOutlined style={{ color: "#52c41a", fontSize: "18px" }} />
    ) : (
      <CloseCircleOutlined style={{ color: "#f5222d", fontSize: "18px" }} />
    );
  };


 


  const LoadingModal = ({ visible }) => {
    if (!visible) return null;
    
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <LoadingPage />
      </div>
    );
  };
  

  // useEffect(() => {
  //   setIsFreightForwarder(usersData?.businessTypeId === 6 );
  // }, [usersData]);

  useEffect(() => {
    const abortController = new AbortController();
    let isMounted = true;


    const fetchPlans = async () => {
      try {
        setInitialLoading(true);
        let response;
    if (isFreightForwarder) {
      response = await axiosInstance.get('/subscription-plans/FreightPlans' ,{ signal: abortController.signal});
    } else if (isExporter) {
      response = await axiosInstance.get('/subscription-plans/ExporterPlans',{ signal: abortController.signal});
    } else if (isManuCumExporter) {
      response = await axiosInstance.get('/subscription-plans/ManuCumExporterPlans',{ signal: abortController.signal});
    } else if (isManufacturerComissionAgent) {
      response = await axiosInstance.get('/subscription-plans/Manufacturer-CommisionagentPlans',{ signal: abortController.signal});
    } else if (isCha) {
      response = await axiosInstance.get('/subscription-plans/freightplan',{ signal: abortController.signal});
    }
     else if (icChaCumFreight) {
      response = await axiosInstance.get('/subscription-plans/ChaCumFreight-Plans',{ signal: abortController.signal});
    }

        if (!isMounted) return;

        if (isFreightForwarder ||isCha || isExporter || isManuCumExporter ||isManufacturerComissionAgent || icChaCumFreight) {
          const allFeatures = new Set();
          response.data.forEach(plan => {
            Object.keys(plan.features).forEach(feature => {
              allFeatures.add(feature);
            });
          });

          const transformedPlans = response.data.map(plan => ({
            id: plan.id,
            planId: plan.planId,
            name: plan.name,
            baseName: plan.baseName,
            price: plan.price,
            priceAmount: plan.priceAmount,
            durationDays: plan.durationDays,
            isYearly: plan.isYearly,
            popular: plan.popular,
            features: plan.features,
              sortOrder: plan.name.toLowerCase() === 'free' ? 0 : 
             plan.name.toLowerCase() === 'basic' ? 1 : 2
          }));

          transformedPlans.sort((a, b) => a.sortOrder - b.sortOrder);

          setFeatures(Array.from(allFeatures));
          setPlans(transformedPlans);
        } else {
          // Process regular plans
          const transformedPlans = response.data.map(apiPlan => {
            const featuresObj = typeof apiPlan.features === 'string' 
              ? JSON.parse(apiPlan.features) 
              : apiPlan.features;
            
            const featuresList = Object.entries(featuresObj)
              .filter(([_, value]) => value)
              .map(([key]) => key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()));

            return {
              planId: apiPlan.id,
              id: apiPlan.name.toLowerCase(),
              name: apiPlan.name === 'free' ? 'Start Free Trial' : 
                    apiPlan.name.charAt(0).toUpperCase() + apiPlan.name.slice(1),
              price: `₹${apiPlan.price}/month`,
              priceAmount: Math.round(parseFloat(apiPlan.price) * 100),
              durationDays: apiPlan.durationDays,
              features: featuresList.length > 0 ? featuresList : 
                      apiPlan.id === 1 ? ["Basic features access", "Limited usage"] :
                      apiPlan.id === 2 ? ["Advanced analytics", "Priority support"] :
                      ["All features", "24/7 premium support"],
              popular: apiPlan.id === 2
            };
          });

          setPlans(transformedPlans);
        }

      } catch (error) {
        if (!abortController.signal.aborted) {
          notification.error({
            message: "Failed to load plans",
            description: error.response?.data?.message || "Error fetching subscription plans"
          });
        }
      } finally {
        if (!abortController.signal.aborted) {
          setInitialLoading(false);
        }
      }
    };

    fetchPlans();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [dispatch, isFreightForwarder,isCha,isExporter,isManuCumExporter,icChaCumFreight]);


 const styles = {
    container: {
      padding: "30px 15px",
      backgroundColor: "#f5f5f5",
      minHeight: "100vh",
    },
    textCenter: {
      textAlign: "center",
    },
    subTitle: {
      display: "block",
      marginBottom: "20px",
      color: "#096dd9",
      textAlign: "center",
    },
    plansRow: {
      marginTop: "20px",
    },
    planCardWrapper: {
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      height: "100%",
    },
    planCard: {
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#ffffff",
      transition: "all 0.3s ease",
      height: "100%",
      position: "relative", // Added for absolute positioning

    },
    popularPlan: {
      border: "2px solid #1890ff",
      transform: "scale(1.05)",
    },
    popularBadge: {
      backgroundColor: "#1890ff",
      color: "#ffffff",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "12px",
      // marginTop: "px",
      display: "inline-block",
    },
    planContent: {
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      height: "calc(100% - 60px)",
    },
    planPrice: {
      color: "#1890ff",
      marginBottom: "20px",
      textAlign: "center",
      // fontSize: "20px",

    },
    featureIcon: {
      color: "#1890ff",
      marginRight: "8px",
      
    },
    subscribeButton: {
      marginTop: "auto",
      backgroundColor: "#1890ff",
      border: "none",
      borderRadius: "8px",
      color: "#ffffff",
      transition: "background-color 0.3s ease",
      justifyContent: "center",
      alignItems: "center",
    },

    mobilePopularBadge: {
      backgroundColor: "#1890ff",
      color: "#ffffff",
      padding: "2px 8px",
      borderRadius: "12px",
      fontSize: "10px",
      marginLeft: "8px"
    },
    
    mobilePrice: {
      color: "#1890ff",
      fontSize: "14px"
    },
    
    mobileFeatureIcon: {
      color: "#1890ff",
      fontSize: "14px",
      marginRight: "6px"
    },
    
    mobileFeatureText: {
      fontSize: "12px"
    },
    
    mobileSubscribeButton: {
      height: "32px",
      fontSize: "14px",
      marginTop: "12px"
    }
  };

 
const [userData, setUserData] = useState(null);

const handleSubscribe = async (plan) => {
  console.log("Attempting to subscribe to:", plan);

  if (plan.planId === 1) { 
    const hasUsedFreePlan = userDatas?.subscription?.planId === 1;
    if (hasUsedFreePlan) {
      notification.warning({
        message: "Free Plan Already Used",
        description: "You can only use the free plan once. Please upgrade to a paid plan.",
      });
      return;
    }
  }
  setShowLoadingModal(true);
   dispatch(fetchStart());
   setLoading(true);
  if (plan.id === "free") {
    try {
      const response = await axiosInstance.post('/subscription-plans/subscribe', {
        planId: plan.planId,
        userId: usersData.id,
        email: usersData.email
      });

      if (response.data.success) {
        notification.success({
          message: "Subscription Successful",
          description: response.data.message || "Free plan activated successfully"
        });

        const updatedUserResponse = await axiosInstance.get(`/subscription-plans/user/${usersData.id}`);
        setUserDatas(prev => ({
          ...prev,
          subscription: updatedUserResponse.data.subscription
        }));
        
        history.push("/");
      } else {
        notification.success({
          message: "Subscription Notice",
          description: response.data.message
        });
        history.push("/");

      }
    } catch (error) {
      // Handle specific error cases
      if (error.response?.data?.code === 'FREE_PLAN_USED') {
        notification.warning({
          message: "Free Plan Limit",
          description: "You can only use the free plan once"
        });
      } else {
        notification.error({
          message: "Subscription Failed",
          description: error.response?.data?.message || "Failed to process subscription"
        });
      }
    } finally {
      dispatch(fetchSuccess());
      setLoading(false);
      setShowLoadingModal(false);
    }
    return;
  }
  setLoading(true);
  
  try {
    // 1. Load Razorpay with error handling
    const discountPercentage = plan.isYearly ? 0.6 : 0.5;
    const discountedPrice = plan.price * (1 - discountPercentage);
    
    // const taxRate = 0.18;
    // const priceWithTax = discountedPrice * (1 + taxRate);
    
    // const amountInPaise = Math.round(priceWithTax * 100);
    const originalPrice = plan.price;

    const amountInPaise = Math.round(originalPrice * 100);


    try {
      dispatch(fetchStart());
      setShowLoadingModal(true);
      await loadRazorpay();
      dispatch(fetchSuccess());

    } catch (error) {
      dispatch(fetchSuccess());
      throw new Error('Could not load payment processor. Please refresh the page.');
    }

    if (!window.Razorpay) {
      throw new Error('Payment system not available');
    }


    // setShowLoadingModal(false); 

    // const amountInPaise = plan.priceAmount;
    console.log('Submitting amount:', amountInPaise, 'paise');

    dispatch(fetchStart());
    let order;
    try {
      order = await createSubscriptionOrder(
        plan.planId,
       amountInPaise,
        'INR',
        plan.baseName,
        plan.isYearly,
        usersData.uuid,
        usersData.id,
        usersData.email
      );
      console.log('Order created:', order);
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchSuccess());
      throw new Error('Failed to create payment order');
    }

    // const RZP_KEY_ID= "rzp_test_5kCkgzLnAK8eb1"

    const checkoutOptions = {
      key: process.env.REACT_APP_RZP_KEY_ID,
      amount: amountInPaise,
      currency: order.currency,
      name: "MY EXIM BUSINESS",
      image: "https://myeximbusiness.com/favicon.ico",
      description: `${plan.name} Subscription`,
      order_id: order.id,
      handler: async (response) => {
        try {
          dispatch(fetchStart());
          setShowLoadingModal(true);
          await verifyRazorpayPayments(
            response.razorpay_order_id,
            response.razorpay_payment_id,
            usersData.uuid,
            response.razorpay_signature,
            
          );

          await axiosInstance.post('/subscription-plans/subscribe', {
            // subscriptionPlan: plan.id,
            planId: plan.planId,
            isYearly: plan.isYearly,
            userId: usersData.id,
            email: usersData.email,
          });
          // setShowLoadingModal(true);
          // Refresh user data
          // const updatedUser = await axiosInstance.get(`/subscription-plans/user/${usersData.id}`);

          const updatedUserResponse = await axiosInstance.get(`/users/${usersData.id}`);
        console.log("updatedUserResponse check>>>>> razorpay Update from ",updatedUserResponse)
          // 4. Update Redux store
          dispatch({
            type: 'UPDATE_USER_DATA',
            payload: updatedUserResponse.data
          });
          if (setUserDatas) {
            setUserDatas(prev => ({
              ...prev,
              subscription: updatedUserResponse.data.subscription
            }));
          }

            const DISPLAY_DURATION = 4500; // 5.5 seconds
            
            // CSS modifications
            <style>{`
              .custom-success-modal .ant-modal-content {
                /* ... existing styles ... */
                overflow: hidden !important;
              }
            
              @keyframes progressBar {
                0% { width: 100%; }
                100% { width: 0%; }
              }
            
              .progress-bar {
                animation-duration: ${DISPLAY_DURATION}ms !important;
              }
            
              /* Add exit animation */
              @keyframes modalExit {
                0% { opacity: 1; transform: scale(1); }
                100% { opacity: 0; transform: scale(0.95); }
              }
            
              .custom-success-modal.ant-modal-wrap {
                animation: modalExit 0.3s ease ${DISPLAY_DURATION}ms forwards;
              }
            `}</style>
            
            // Modal implementation
            Modal.success({
              className: 'custom-success-modal',
              centered: true,
              maskStyle: { background: 'rgba(0,0,0,0.4)' },
              width: 520,
              icon: null,
              okButtonProps: { style: { display: 'none' } },
              cancelButtonProps: { style: { display: 'none' } },
              title: (
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#1a3353',
                  marginBottom: '16px'
                }}>
                  <CheckCircleFilled style={{ 
                    color: '#52c41a', 
                    fontSize: '28px',
                    marginRight: '12px'
                  }} />
                  Payment Successful!
                </div>
              ),
              content: (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ 
                    color: '#595959', 
                    lineHeight: '1.6',
                    marginBottom: '24px'
                  }}>
                    <p style={{ margin: '0 0 16px 0', fontSize: '16px' }}>
                    Your {plan.name} subscription is now active.
                    </p>
                    
                
                  </div>
                  <div className="progress-bar" />
                </div>
              ),
              afterClose: () => Modal.destroyAll(),
            });

          setTimeout(() => {
            Modal.destroyAll();
          }, DISPLAY_DURATION);
          
          Modal.config({
            duration: DISPLAY_DURATION / 1000 
          });
          history.push("/");
        } catch (error) {
          // onSubscriptionFailure();
          notification.error({
            message: "Verification Failed",
            description: error.message,
          });
        
      } finally {
        dispatch(fetchSuccess());
        setShowLoadingModal(false);
      }
      },
      prefill: {
        name: usersData.name ,
        email: usersData.email,
        contact: usersData.mobile
      },
      notes: {
        planId: plan.planId,
        userId: usersData.id
      },
      theme: {
        color: '#1890ff' 
      }
    };

    console.log('Razorpay options:', checkoutOptions);

    const rzp = new window.Razorpay(checkoutOptions);
    
    rzp.on('payment.failed', (response) => {
      notification.error({
        message: "Payment Failed",
        description: response.error.description || "Payment could not be completed",
      });
    });
    setShowLoadingModal(false);
    rzp.open();
    dispatch(fetchSuccess());

  } catch (error) {
    console.error('Subscription error:', error);
    notification.error({
      message: "Error",
      description: error.message || "Failed to process subscription",
    });
  } finally {
    setLoading(false);
    setShowLoadingModal(false);
    dispatch(fetchSuccess());
  }
};

  // ... (keep all other existing functions like handleSubscribe, renderFeatureCell, etc.)

  // const PlanDurationToggle = () => (
  //   <div style={{ 
  //     display: 'flex', 
  //     justifyContent: 'center', 
  //     marginBottom: 0,
  //     background: '#f5f5f5',
  //     borderRadius: 20,
  //     padding: 0,
  //     maxWidth: 300,
  //     margin: '0 auto 0px'
  //   }}>
  //     <Button
  //       type={planDuration === 'monthly' ? 'primary' : 'text'}
  //       onClick={() => setPlanDuration('monthly')}
  //       style={{
  //         borderRadius: 16,
  //         width: '40%',
  //         fontWeight: planDuration === 'monthly' ? 600 : 400,
  //         backgroundColor:'#e5eaf2'
  //       }}
  //     >
  //       Monthly
  //     </Button>
  //     <Button
  //       type={planDuration === 'yearly' ? 'primary' : 'text'}
  //       onClick={() => setPlanDuration('yearly')}
  //       style={{
  //         borderRadius: 16,
  //         width: '55%',
  //         fontWeight: planDuration === 'yearly' ? 600 : 400,
  //         backgroundColor:'#e5eaf2'
  //       }}
  //     >
  //       Yearly (Save 60%)
  //     </Button>
  //   </div>
  // );

  const FreightForwarderPlans = () => {
    // Filter plans based on duration
    // const filteredPlans = plans.filter(plan => 
    //   (planDuration === 'monthly' && !plan.isYearly) ||
    //   (planDuration === 'yearly' && plan.isYearly)
    // )
    //   .sort((a, b) => {
    //   if (a.sortOrder !== b.sortOrder) {
    //     return a.sortOrder - b.sortOrder;
    //   }
    //   return a.isYearly - b.isYearly;
    // });


const filteredPlans = plans.filter(plan => plan.isYearly)
    .sort((a, b) => a.sortOrder - b.sortOrder);

    // Calculate savings for yearly plans
    const getSavingsPercentage = (yearlyPlan) => {
      const monthlyPlan = plans.find(p => 
        p.baseName === yearlyPlan.baseName && !p.isYearly
      );
      if (!monthlyPlan) return 0;
      return Math.round((1 - yearlyPlan.price / (monthlyPlan.price * 12)) * 100);
    };
  
    // Enhanced feature cell renderer
    const renderFeatureCell = (value) => {
      if (typeof value === 'boolean') {
        return value ? (
          <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 18 }} />
        ) : (
          <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: 18 }} />
        );
      }
      return value || '-';
    };
  
  const columns = [
  {
    title: "Features",
    dataIndex: "feature",
    key: "feature",
    width: "40%",
    render: (text) => <Text strong>{text}</Text>
  },
  ...filteredPlans.map((plan) => ({
    title: (
      <div style={{ textAlign: "center" }}>
        <div style={{ fontWeight: 600, fontSize: "18px", marginBottom: 8 }}>
          {plan.baseName}
          {plan.popular && (
            <Tag color="#1890ff" style={{ 
              marginLeft: 8, 
              fontSize: "12px",
              fontWeight: 600,
              borderRadius: 12,
              padding: '0 8px'
            }}>
              POPULAR
            </Tag>
          )}
        </div>
      </div>
    ),
    dataIndex: plan.name.toLowerCase(),
    key: plan.id,
    align: "center",
    render: (value, record) => {
      if (record.key === 'pricing') {
        const discountPercentage = plan.isYearly ? 0.6 : 0.5;
        const discountedPrice = (plan.price * (1 - discountPercentage)).toFixed(2);
        const originalPrice = plan.price;

        return (
          <div style={{ textAlign: 'center' }}>
            {/* {plan.planId !== 1 && (
            <div style={{ 
              textDecoration: 'line-through',
              color: '#999',
              fontSize: '16px'
            }}>
              ₹{plan.price}
            </div>
            )} */}
            {plan.planId !== 1 && (
            <div style={{ 
              fontSize: "24px", 
              fontWeight: 700, 
              margin: "4px 0",
              color: plan.popular ? '#1890ff' : 'inherit'
            }}>
              ₹{originalPrice}

              <span style={{
                fontSize: '14px',
                fontWeight: 'normal',
                color: '#666',
                marginLeft: 4
              }}>
                /{plan.isYearly ? 'year' : 'month'}
              </span>
            </div>
            )}
            
           {/* {plan.planId !== 1 && (
              <div style={{ 
                background: '#f6ffed',
                border: '1px solid #b7eb8f',
                color: '#52c41a',
                fontSize: 12,
                padding: '4px 8px',
                borderRadius: 4,
                margin: '4px auto',
                width: 'fit-content'
              }}>
                {plan.isYearly ? '60% OFF' : '50% OFF'}
              </div>
            )} */}
            
           {plan.planId !== 1 && (
              <div style={{ 
                fontSize: '12px', 
                color: '#999', 
                marginTop: '4px'
              }}>
                (Excluding GST ) 
              </div>
            )}
          </div>
        );
      }
      
      if (record.key === 'action') {
        if (plan.planId === 1) {
          return <div style={{ textAlign: 'center' }}></div>;
        }
        return (
          <div style={{ textAlign: 'center' }}>
            <Button
              type={plan.popular ? "primary" : "default"}
              size="large"
              style={{ width: '80%' }}
              onClick={() => handleSubscribe(plan)}
            >
              Subscribe
            </Button>
          </div>
        );
      }
      
      return renderFeatureCell(plan.features[record.feature]);
    },
  })),
];
    // Create data source with features plus pricing/action rows
    const dataSource = [
      ...features.map((feature) => ({
        key: feature,
        feature: feature,
        ...filteredPlans.reduce((acc, plan) => {
          // We need to store the plan name to access it in render
          acc[plan.name.toLowerCase()] = { type: 'feature', value: plan.features[feature] };
          return acc;
        }, {}),
      })),
      {
        key: 'pricing',
        feature: 'Pricing',
        ...filteredPlans.reduce((acc, plan) => {
          acc[plan.name.toLowerCase()] = { type: 'pricing' };
          return acc;
        }, {}),
      },
      {
        key: 'action',
        feature: '',
        ...filteredPlans.reduce((acc, plan) => {
          acc[plan.name.toLowerCase()] = { type: 'action' };
          return acc;
        }, {}),
      }
    ];
  
    // Mobile view remains the same
    if (isMobile) {
      return (
        <div style={{ padding: '0 16px' }}>
          <Collapse accordion defaultActiveKey={['1']} style={{ marginBottom: 24 }}>
            {filteredPlans.map((plan) => (
              <Panel 
                header={
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                    <span style={{ fontWeight: 600 }}>
                      {plan.baseName} 
                      {plan.popular && (
                        <Tag color="#1890ff" style={{ 
                          marginLeft: 8, 
                          fontSize: "10px",
                          fontWeight: 600,
                          borderRadius: 12,
                          padding: '0 6px'
                        }}>
                          POPULAR
                        </Tag>
                      )}
                    </span>
                    <span style={{ fontWeight: 700 }}>
                      ₹{plan.price}/{plan.isYearly ? 'year' : 'month'}
                    </span>
                  </div>
                } 
                key={plan.id}
              >
                <List
                  dataSource={features}
                  renderItem={(feature) => (
                    <List.Item style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {renderFeatureCell(plan.features[feature])}
                        <Text style={{ marginLeft: 12 }}>{feature}</Text>
                      </div>
                    </List.Item>
                  )}
                />
                <div style={{ marginTop: 16 }}>
                  {plan.planId !== 1 && (
                  <Button
                    type={plan.popular ? "primary" : "default"}
                    block
                    size="large"
                    onClick={() => handleSubscribe(plan)}
                  >
                    Get Started
                  </Button>)}
                  {plan.isYearly && plan.planId !== 1 && (
                    <div style={{ 
                      textAlign: 'center', 
                      marginTop: 8,
                      fontSize: 12,
                      color: '#52c41a'
                    }}>
                      Save {getSavingsPercentage(plan)}% compared to monthly
                    </div>
                  )}
                
                </div>
              </Panel>
            ))}
          </Collapse>
        </div>
      );
    }
  
    return (
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          bordered
          style={{ marginBottom: 24 }}
          rowClassName={(record) => 
            record.key === 'pricing' ? 'pricing-row' : 
            record.key === 'action' ? 'action-row' : 'feature-row'
          }
        />
      </div>
    );
  };

 const MobilePlanCard = ({ plan, handleSubscribe, loading }) => {
    const isPopular = plan.popular;
    const priceParts = plan.price.split('/');
  
    return (
      <Card
        style={{
          marginBottom: 24,
          borderRadius: 16,
          border: `2px solid ${isPopular ? '#1890ff' : '#e8e8e8'}`,
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
          background: isPopular ? 'linear-gradient(135deg, #f8fbff 0%, #f3f9ff 100%)' : '#fff',
          position: 'relative',
          overflow: 'hidden',
        }}
        bodyStyle={{ padding: 16 }}
      >
        {isPopular && (
          <div style={{
            position: 'absolute',
            top: 12,
            right: -32,
            background: '#1890ff',
            color: '#fff',
            padding: '4px 32px',
            transform: 'rotate(45deg)',
            fontSize: 12,
            fontWeight: 600,
            width: 120,
            textAlign: 'center',
          }}>
            MOST POPULAR
          </div>
        )}
  
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: 16 
        }}>
          <div>
            <Title level={4} style={{ 
              margin: 0, 
              color: '#1a3353',
              fontWeight: 600 
            }}>
              {plan.name}
            </Title>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {plan.durationDays}-day cycle
            </Text>
          </div>
          <Tag
            color="#1890ff"
            style={{ 
              borderRadius: 20, 
              padding: '4px 12px',
              background: 'rgba(24, 144, 255, 0.1)',
              border: 'none',
              color: '#1890ff',
              fontWeight: 500
            }}
          >
            {priceParts[1]}
          </Tag>
        </div>
  
        {/* Price Display */}
        <div style={{ 
          backgroundColor: 'rgba(24, 144, 255, 0.05)',
          borderRadius: 8,
          padding: 16,
          marginBottom: 16
        }}>
          <Text style={{
            fontSize: 28,
            fontWeight: 700,
            color: '#1890ff',
            lineHeight: '1.2'
          }}>
            {priceParts[0]}
            <span style={{
              fontSize: 14,
              fontWeight: 500,
              color: '#7a869a',
              marginLeft: 8
            }}>
              per month
            </span>
          </Text>
        </div>
  
        {/* Features List */}
        <List
          dataSource={plan.features}
          renderItem={(feature) => (
            <List.Item style={{ 
              padding: '12px 0',
              borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
              display: 'flex',
              alignItems: 'center'
            }}>
              <CheckCircleOutlined style={{
                color: '#1890ff',
                fontSize: 18,
                marginRight: 12
              }} />
              <Text style={{ 
                fontSize: 14, 
                color: '#3d4d65',
                fontWeight: 500 
              }}>
                {feature}
              </Text>
            </List.Item>
          )}
        />
  
        {/* CTA Button */}
        <Button
          type="primary"
          block
          size="large"
          loading={loading}
          style={{
            height: 48,
            borderRadius: 12,
            fontWeight: 600,
            fontSize: 16,
            background: isPopular ? '#1890ff' : '#e6f4ff',
            border: 'none',
            color: isPopular ? '#fff' : '#1890ff',
            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.2)',
            marginTop: 16
          }}
          onClick={() => handleSubscribe(plan)}
        >
          {plan.id === "free" ? 'Start Free Trial' : 'Subscribe'}
        </Button>
      </Card>
    );
  };


  if (initialLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
      }}>
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} 
          tip="Loading plans..."
        />
      </div>
    );
  }

  // Add empty state handling
  if (!plans.length) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '50px 20px',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Title level={4} style={{ marginBottom: 24 }}>
          No subscription plans available
        </Title>
        <Button 
          type="primary" 
          onClick={() => {
            setInitialLoading(true);
            // fetchPlans();
          }}
          style={{ width: 200 }}
        >
          Try Again
        </Button>
      </div>
    );
  }


  return (
    // <Card>    
    <div style={styles.container}>
    <LoadingModal visible={showLoadingModal} />
      <Title level={2} style={styles.textCenter}>
        Choose Your Plan
      </Title>
       {/* <PlanDurationToggle /> */}
      <Text style={styles.subTitle}>
        Select a plan that suits your needs and unlock premium features.
      </Text>

     
      {isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 34 }} spin />} tip="Loading plans..." />

</div>    ) : isFreightForwarder || isCha ||isExporter || isManuCumExporter || isManufacturerComissionAgent ||icChaCumFreight  ? (
      // Render freight forwarder specific plans
      <>
        {/* <PlanDurationToggle /> */}
       <FreightForwarderPlans />
      </>
    ) : isMobile ? (
      <div style={{ padding: '0 16px' }}>
        {plans.map((plan) => (
          <MobilePlanCard 
            key={plan.id}
            plan={plan}
            handleSubscribe={handleSubscribe}
            loading={loading}
          />
        ))}
      </div>
    ) : (
      <Row gutter={[24, 24]} justify="center" style={styles.plansRow}>
        {plans.map((plan, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={7}>
            <div
              style={styles.planCardWrapper}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = plan.popular 
                  ? "translateY(-5px) scale(1.02)"
                  : "translateY(-5px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
              }}
            >
              <Card
                style={{
                  ...styles.planCard,
                  ...(plan.popular && styles.popularPlan),
                }}
                title={
                  <div style={styles.textCenter}>
                    <Title level={4}>{plan.name}</Title>
                    {plan.popular && (
                      <div style={styles.popularBadge}>
                        <Text strong>Most Popular</Text>
                      </div>
                    )}
                  </div>
                }
              >
                <div style={styles.planContent}>
                  <Title level={2} style={styles.planPrice}>
                    {plan.price}
                  </Title>
                  
                  <List
                    dataSource={plan.features}
                    renderItem={(feature) => (
                      <List.Item  style={{ 
                        padding: '8px 0',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                        display: 'flex',
                        alignItems: 'flex-start',
                        margin: 0
                      }}>
                        <CheckCircleOutlined style={styles.featureIcon} />
                        <Text >{feature}</Text>
                      </List.Item>
                    )}
                    style={{
                      margin: '6px'
                    }}
                  
                  />
                  
                  <Button
                    type="primary"
                    block
                    size="large"
                    style={styles.subscribeButton }
                    loading={loading}
                    onClick={() => handleSubscribe(plan)}
                  >
                    {plan.id === "free" ? "Subscribe" : "Subscribe"}
                  </Button>
                </div>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    )}

    </div>
    // </Card>
  );
  }
export default SubscriptionPlans;